class VerificationController {
  constructor($scope, $state, $rootScope, AuthService, $timeout, ProfileService, $localStorage) {
    this.name = "verification";
    this.$rootScope = $rootScope;
    this.$profile = ProfileService;
    this.$auth = AuthService;
    this.$state = $state;
    this.$localStorage = $localStorage;
    this.$scope = $scope;
    this.currentUser = this.$auth.getUserData();
    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
    this.$timeout = $timeout;
    this.is_clickable = true;
    var _this = this;

    _this.SetResumeDataListener = _this.$rootScope.$on("SetResumeData", function ($event, params) {
      _this.determineResumeType(params.user.resumeLink);
    });

    _this.SetDataForVerificationListener = _this.$rootScope.$on("SetDataForVerification", function ($event, params) {
      console.log("SetDataForVerificationListener");
      console.dir(params);
      _this.currentUser = params.user;
      _this.user = params.user;
      _this.job = params.job;
      _this.success = false;
      _this.error = false;
    });

    _this.$scope.$on("$destroy", _this.SetDataForVerificationListener);
    _this.$scope.$on("$destroy", _this.SetResumeDataListener);
  }

  resendEmail() {
    var _this = this;

    console.log("resend email");
    console.dir(_this.user);
    console.dir(_this.currentUser);
    let user = null;
    if (_this.user) {
      user = _this.user;
    } else {
      user = _this.currentUser;
    }
    _this.setLoader();
    _this.$profile.resendEmail(user).then(
      function (response) {
        console.log("response");
        console.dir(response);
        _this.unSetLoader();
        _this.success = true;
      },
      function (error) {
        console.log("error");
        console.dir(error);
        _this.error = true;
        _this.unSetLoader();
      }
    );
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  closeVerificationModal() {
    var _this = this;
    _this.$timeout(function () {
      $("#need-basic-information-data").modal("toggle");
    });

    let job = _this.job;

    _this.$timeout(function () {
      _this.$state.go("jobbler", {job, check_user: true});
    }, 300);
  }

  checkVerificationStatus() {
    var _this = this;
    _this.setLoader();
    _this.$profile.checkValidationStatus().then(
      function (response) {
        _this.unSetLoader();
        if (response.data.isVerified === false) {
          _this.$timeout(function () {
            $("#user-not-verified").modal("toggle");
          });

          //do something
          /*
				  _this.$timeout(function(){
					  _this.$rootScope.$emit("UserHasConfirmedTheirEmail",{});
				  });
				  */
        } else {
          _this.currentUser.isVerified = true;
          _this.$timeout(function () {
            //$("#user-not-verified").modal("toggle");
            _this.$rootScope.$emit("UserHasConfirmedTheirEmail", {});
          });
        }
      },
      function (error) {
        _this.unSetLoader();
        alert("There was an error verifying your account. Please try again.");
      }
    );
  }

  selectResume() {
    var _this = this;
    _this.$timeout(function () {
      $("#resume-upload-modal .resume-input").trigger("click");
      $("#resume-upload-modal .resume-input").change((event) => {
        if (_this.is_clickable) {
          _this.uploadResume(event);
        }
      });
    });
  }

  uploadResume() {
    var _this = this;
    _this.is_clickable = false;
    _this.$timeout(function () {
      let file = $("#resume-upload-modal .resume-input")[0].files[0];
      let fd = new FormData();
      fd.append("file", file);
      _this.setLoader();
      _this.$profile.uploadResume(fd).then(
        function (response) {
          _this.is_clickable = true;
          _this.determineResumeType(response.data.mainFile.url);
          _this.unSetLoader();
          _this.$localStorage.logged_user.resumeLink = response.data.mainFile.url;
        },
        function (error) {
          _this.unSetLoader();
          _this.is_clickable = true;
          alert("There was an issue uploading your resume. Please try another file.");
        }
      );
    });
  }

  determineResumeType(link) {
    var _this = this;
    if (link) {
      _this.resumeText = "Change Resume";
      if (link.indexOf(".pdf?") > -1) {
        _this.isPdf = true;
      } else {
        _this.isPdf = false;
      }
      _this.resumeLink = link;
    } else {
      _this.resumeText = "Upload Resume";
    }
  }
}

VerificationController.$inject = ["$scope", "$state", "$rootScope", "auth", "$timeout", "profile", "$localStorage"];

export default VerificationController;



// WEBPACK FOOTER //
// ./client/app/common/verification/verification.controller.js